"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertAction = exports.createAlertAction = exports.toggleAlert = exports.showAlert = exports.removeAlert = exports.hideAlert = exports.clearAlert = exports.addAlert = void 0;
const Keys_1 = require("./Keys");
const addAlert = (payload) => ({
    type: Keys_1.AlertActionTypes.Add,
    payload,
});
exports.addAlert = addAlert;
const clearAlert = (payload) => ({
    type: Keys_1.AlertActionTypes.Clear,
    payload,
});
exports.clearAlert = clearAlert;
const hideAlert = (payload) => ({
    type: Keys_1.AlertActionTypes.Hide,
    payload: {
        ...payload,
        state: Keys_1.ToggleType.Hide,
    },
});
exports.hideAlert = hideAlert;
const removeAlert = (payload) => ({
    type: Keys_1.AlertActionTypes.Remove,
    payload,
});
exports.removeAlert = removeAlert;
const showAlert = (payload) => ({
    type: Keys_1.AlertActionTypes.Show,
    payload: {
        ...payload,
        state: Keys_1.ToggleType.Show,
    },
});
exports.showAlert = showAlert;
const toggleAlert = (payload) => ({
    type: Keys_1.AlertActionTypes.Toggle,
    payload,
});
exports.toggleAlert = toggleAlert;
const createAlertAction = () => ({
    add: exports.addAlert,
    clear: exports.clearAlert,
    hide: exports.hideAlert,
    remove: exports.removeAlert,
    show: exports.showAlert,
    toggle: exports.toggleAlert,
});
exports.createAlertAction = createAlertAction;
exports.alertAction = (0, exports.createAlertAction)();
